import cn from 'classnames'
import { ArrowCta } from '@mc/certificates-design-system'
import { useTranslation } from '@mc/i18n'
import { TrackClick } from 'pages/certificates/tracking'
import type { Responsive } from '../types'
import { ResponsiveText } from './ResponsiveText'
import type { StateCopyView } from './getStateCopy'

type CohortStateBlockProps = {
  copy: StateCopyView
  joinLabel: Responsive<string>
  onNotify?: () => void
  align?: 'end' | 'between'
}

export const CohortStateBlock = ({
  copy,
  joinLabel,
  onNotify,
  align = 'end',
}: CohortStateBlockProps) => {
  const { t } = useTranslation('@mc/certificates')
  const notifyLabel = t('marketingPages.cohorts.notify.cta')

  return (
    <div
      className={cn('flex items-center justify-between gap-5', {
        'lg:justify-end': align === 'end',
      })}
    >
      <div className='flex flex-col gap-1'>
        <p className='c-caption-mono m-0 uppercase text-c-brand-highlight'>
          {copy.label}
        </p>
        <p className='c-body-xsmall m-0 text-c-beige-100'>
          {copy.kind === 'join'
            ? copy.deadline
            : t('marketingPages.cohorts.notify.subline')}
        </p>
      </div>
      {copy.kind === 'join' ? (
        // TODO(MCCERTS-3063): no target until cohort checkout exists
        <TrackClick
          event='purchaseClick'
          action={typeof joinLabel === 'string' ? joinLabel : joinLabel.desktop}
        >
          <ArrowCta kind='accent' type='button'>
            <ResponsiveText value={joinLabel} />
          </ArrowCta>
        </TrackClick>
      ) : (
        <TrackClick event='certificateLandingClick' action={notifyLabel}>
          <ArrowCta
            kind='accent'
            type='button'
            aria-haspopup='dialog'
            onClick={onNotify}
          >
            {notifyLabel}
          </ArrowCta>
        </TrackClick>
      )}
    </div>
  )
}
